<script setup lang="ts">
import ModalWithButtons from '@/components/Modal/ModalWithButtons.vue'
import TeamTrialButton from '@/components/TeamTrialButton .vue'
import { useProPlanCheckout } from '@/hooks/usePayment'
import { PRO_PLAN_PRICE } from '@WombatTechnology/nitte-time-lib'

const emits = defineEmits<{
  (e: 'close'): void
  (e: 'compare'): void
}>()
const { buttonState, checkout } = useProPlanCheckout()
</script>

<template>
  <div>
    <ModalWithButtons @close="emits('close')">
      <template #title> Nitteをより活用しよう! </template>
      <template #description>
        <div class="lo-v-end">
          <slot name="description" />
          <a @click="emits('compare')">プランを比較する</a>
        </div>
      </template>
      <template #contents>
        <!-- アップグレード -->
        <div class="lo-v-center">
          <main-title class="lo-h-baseline">
            {{ PRO_PLAN_PRICE }}円<description class="mg-left-4px">
              /月(税込)
            </description>
          </main-title>
          <NitButton
            class="mg-top-8px"
            :button-state="buttonState"
            @click="checkout"
          >
            プロプランにアップグレード
          </NitButton>
          <sup-label class="gray-1 mg-top-4px">
            決済サービス<a href="https://stripe.com/jp">Stripe</a>に遷移します。
          </sup-label>
        </div>

        <!-- チームトライアル動線 -->
        <div class="lo-v-center mg-top-40px">
          <description>
            チームでの利用は、チームプランがおすすめです。
          </description>
          <TeamTrialButton />
        </div>
      </template>
    </ModalWithButtons>
  </div>
</template>
